<template>
  <div class="gazette">
    <a v-for="item in gazette" :href="item.pdf" target="_blank">
      {{item.name}}
    </a>
    <!--<div class="grid">-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Sept_2021.pdf">Gazette de Septembre 2021</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Octobre_2020.pdf">Gazette de Octobre 2020</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Mai_2020.pdf">Gazette de Mai 2020</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Mars_2020.pdf">Gazette de Mars 2020</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Sept_2019.pdf">Gazette de Septembre 2019</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_MAi_2019.pdf">Gazette de Mai 2019</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Janv_2019.pdf">Gazette de Janvier 2019</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Sept_2018.pdf">Gazette de Septembre 2018</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Mai_2018.pdf">Gazette de Mai 2018</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Jan_2018.pdf">Gazette de Janvier 2018</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Oct_2017.pdf">Gazette d'Octobre 2017</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Mai_2017_A4.pdf">Gazette de Mai 2017</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Oct_2016_A4.pdf">Gazette d'Octobre 2016</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Mai_2016_A4.pdf">Gazette de Mai 2016</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Janvier_2016_A4.pdf">Gazette de Janvier 2016</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Octobre_2015_A4.pdf">Gazette d’Octobre 2015</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Mai_2015_A4.pdf">Gazette de Mai 2015</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Janvier_2015_A4.pdf">Gazette de Janvier 2015</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Octrobre_2014_A4.pdf">Gazette d'Octobre 2014</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Mai_2014_A4.pdf">Gazette de Mai 2014</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Janvier_2014_A4.pdf">Gazette de Janvier 2014</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Octobre_2013_A4.pdf">Gazette d’Octobre 2013</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Mai_2013_A4.pdf">Gazette de Mai 2013</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Fev2013_A4.pdf">Gazette de Février 2013</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Sept2012_A4.pdf">Gazette de Septembre 2012</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Mai2012_A4.pdf">Gazette de Mai 2012</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Janv2012_A4.pdf">Gazette de Janvier 2012</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Sept2011_A4.pdf">Gazette de Septembre 2011</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_20ans.pdf">Gazette des 20 ANS</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_mai2011_A4.pdf">Gazette de Mai 2011</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Janv2011_A4.pdf">Gazette de Janvier 2011</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Sept2010_A4.pdf">Gazette de Septembre 2010</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_mai2010_A4.pdf">Gazette de Mai 2010</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Janv2010_A4.pdf">Gazette de Janvier 2010</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Sept09_A4.pdf">Gazette de Septembre 2009</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Mai09_site.pdf">Gazette de Mai 2009</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Janv09_site2.pdf">Gazette de Janvier 2009</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_sept08.pdf">Gazette de Septembre 2008</a>-->
      <!--<a class="row" target="_blank" href="http://www.asspm.fr/upload/Gazette_Janv08.pdf">Gazette de Janvier 2008</a>-->
    <!--</div>-->
  </div>
</template>

<script>

  export default {
    name: 'Gazette',
    props: {},
    created() {
      console.log("Gazette created")
      this.gazette = {};
      this.$root.$data.gazette.all()
        .then(g => this.gazette = _.orderBy(g, "order", "desc"))
    },
    methods: {
    },
    data() {
      return {
        gazette: {}
      }
    }
  }

</script>

<style scoped lang="stylus">
  .gazette
    a
      margin 10px !important
      border 1px solid
      padding 10px
      display inline-block  
</style>  